module.exports = __webpack_public_path__ + "static/img/RE8.795d0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE8.jpg
// module id = Bw36
// module chunks = 0